module.exports = __webpack_public_path__ + "img/f38.7483994f.png";